export default {
  username: 'Username',
  password: 'Password',
  submit: 'Esegui la login',
  continue: "Continua senza effettuare l'accesso",
  error:
    "C'è un errore oppure l'username o la password sono errati.<br/> La pagina verrà ricaricata tra qualche secondo oppure procedi manualmente.",
}
